import React from 'react'
import './styles.scss'

export default function region (props: {reg: string, pop: string, ar: string}) {
  const textElements = {
    'Land': 'leben auf dem Land ',
    'Periurban': 'leben in periurbanen Gemeinden ',
    'Städtisch': 'leben in städtischen Gemeinden ',
    'Stadt': 'leben in den zehn grössten Städten '
  }

  const graphicElements = {
    'Land': require('./img/map-land.png'),
    'Periurban': require('./img/map-periurban.png'),
    'Städtisch': require('./img/map-staedtisch.png'),
    'Stadt': require('./img/map-stadt.png')
  }

  let regClass = props.reg.toLowerCase()
  let populationPercentage = Math.round(props.pop * 10) / 10
  let populationPercentageTxt = populationPercentage.toString().replace('.', ',')
  let areaPercentage = Math.round(props.ar * 10) / 10
  let areaPercentageTxt = areaPercentage.toString().replace('.', ',')

  let barStyle = {
    width: populationPercentage + '%'
  }

  let percStyle = {
    textAlign: 'center',
    width: '100%',
    margin: '0',
    padding: '0 0.3em',
    top: '1px'
  }

  return (
    <div className={`region ${regClass}`}>
      <h4 className={`${props.reg}`} >{props.reg}</h4>
      <div className='percBar'>
        <div className='amount' style={barStyle}>&nbsp;</div>
        <div className='percValue' style={percStyle}>{populationPercentageTxt}%</div>
      </div>
      <div className='regionText'>{textElements[props.reg]}</div>
      <img src={graphicElements[props.reg]} alt='' className='ui fluid image' />
      <div className='areaText'>auf {areaPercentageTxt}% der Fläche.</div>
    </div>
  )
}
